import React from 'react'
import { Formik, Form, useFormikContext } from 'formik'
import {
  Box,
  Button,
  Drawer,
  Typography,
  Stack,
  Divider,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import type { FilterBottomSheetProps, FormState } from './types'

const EMPTY_FORM: FormState = {
  status: [],
  method: [],
  dateRange: [null, null],
  period: '',
  stationName: '',
}

export const FilterBottomSheet: React.FC<FilterBottomSheetProps> = ({
  filters,
  onApply,
  onClear,
  isOpen,
  onClose,
  children,
  buildFormState,
  buildAppliedFilters,
}) => {
  const handleSubmit = (values: FormState) => {
    onApply(buildAppliedFilters(values))
    onClose()
  }

  return (
    <Drawer
      anchor="bottom"
      open={isOpen}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          maxHeight: '80vh',
        },
      }}
    >
      <Formik<FormState>
        initialValues={buildFormState(filters)}
        onSubmit={handleSubmit}
      >
        <FilterFormContent onClose={onClose} onClear={onClear}>
          {children}
        </FilterFormContent>
      </Formik>
    </Drawer>
  )
}

const FilterFormContent: React.FC<{ onClose: () => void; onClear: () => void; children?: React.ReactNode }> = ({
  onClose,
  onClear,
  children,
}) => {
  const { resetForm } = useFormikContext<FormState>()

  const handleClear = () => {
    resetForm({ values: EMPTY_FORM })
    onClear()
  }

  return (
    <Form>
      <Box sx={{ p: 2, pb: 4 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Typography variant="h6">Filtros</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>

        <Divider sx={{ mb: 2 }} />

        {children}

        <Stack direction="row" spacing={1}>
          <Button variant="outlined" fullWidth onClick={handleClear} sx={{ flex: 1 }}>
            Limpar filtros
          </Button>
          <Button type="submit" variant="contained" fullWidth sx={{ flex: 1 }}>
            Aplicar
          </Button>
        </Stack>
      </Box>
    </Form>
  )
}
